import { ScButtonCross } from 'components/buttons/styled';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScEmailConfirmPopup = styled.div`
  position: fixed;
  inset: 0 0 auto;
  background-color: ${({ theme }) => theme.grayColor6};
  min-height: 32px;
  z-index: 112;

  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 4px 48px;
  @media (${device.mobileS}) {
    padding-left: 16px;
    justify-content: flex-start;
  }

  .text {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    column-gap: 4px;
    color: ${({ theme }) => theme.whiteColor};
    @media (${device.mobileS}) {
      justify-content: flex-start;
    }

    & > .link {
      color: ${({ theme }) => theme.secondaryColor};
      text-decoration-line: underline;
      color: ${({ theme }) => theme.greenColor};
      cursor: pointer;
    }
  }
  ${ScButtonCross} {
    top: 50%;
    transform: translateY(-50%);
  }
`;
